import { useLazyQuery } from '@apollo/client'
import Box from '@mui/material/Box'
import { BoxProps } from '@mui/system'
import { BorderColor } from 'appconstants/AppColors'
import SVGCancel from 'assets/SVGCancel'
import gqlCaller from 'graphql/gqlcaller'
import { GET_LEAD_STATE } from 'graphql/queries'
import { AlertDialogContext } from 'hooks/AlertDialogContext'
import { useAppDispatch, useAppSelector } from 'hooks/redux-hooks'
import { LeadStateModel, StepModel } from 'models/LeadStateModel'
import { OwnershipType } from 'pages/home/data'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { leadStateData } from 'redux/reducers/auth'
import routes from 'routes'
import { Pages } from 'routes/types'
import { consoleLog } from 'utils/Logger'
import { isEmpty } from 'utils/validation'
import { Step } from './Step'

// TODO: Move to models
export type StepItem = {
  step: number
  label: string
  status: status
  type: Pages
  name: string
}

// TODO: Move to models
export type status = 'pending' | 'inprogress' | 'completed' | 'disabled'

// TODO: Move to utils
export const getNextNavigation = (
  currentScreenName: string,
  leadResponse: LeadStateModel,
): string => {
  let nextScreen = 1
  const currentScreenIndex = leadResponse.merchantOnboardingStateV2?.steps.findIndex(
    (item) => item.type === currentScreenName,
  )
  if (currentScreenIndex === -1) {
    console.error('Error finding current screen index.')
    nextScreen = 1
  } else {
    nextScreen = currentScreenIndex + 1
  }
  return leadResponse.merchantOnboardingStateV2?.steps[nextScreen]?.type
}

// TODO: Move to utils
export const getNextNavigationPath = (
  currentScreenName: string,
  leadResponse: LeadStateModel,
): string => {
  const route = getNextNavigation(currentScreenName, leadResponse)
  if (!route) {
    console.error('Route not found.')
  } else if (!routes[route]) {
    console.error('Route path not found.')
  }
  return routes?.[route]?.path?.replace(/\/\*$/, '')
}

// TODO: Move to utils
export const getNextNavigationFirstEditable = (leadResponse: LeadStateModel): string => {
  const steps = leadResponse?.merchantOnboardingStateV2?.steps.filter((item) => {
    return item?.editableConfig?.editable
  })

  if (isEmpty(steps)) {
    return Pages.PanDetail
  }

  return steps[0].type
}

// TODO: Move to utils
export const getNextNavigationSecondLast = (leadResponse: LeadStateModel): string => {
  const step =
    leadResponse?.merchantOnboardingStateV2?.steps[
      leadResponse?.merchantOnboardingStateV2?.steps.length - 2
    ]

  if (isEmpty(step)) {
    return Pages.PanDetail
  }

  return step.type
}

// TODO: Move to utils
export const getMenu = (ownershipType: OwnershipType): Array<StepItem> => {
  if (ownershipType === OwnershipType.PARTNERSHIP) {
    return menuListPartnerShip
  } else {
    return menuList
  }
}

// TODO: Move to constants
export const menuList: StepItem[] = [
  {
    step: 1,
    label: 'Lead details',
    status: 'pending',
    name: 'LEAD_CREATION',
    type: Pages.CreateLead,
  },
  {
    step: 2,
    label: 'PAN/ GST details',
    status: 'pending',
    name: 'PAN/GST',
    type: Pages.PanDetail,
  },
  {
    step: 3,
    label: 'Business details',
    status: 'pending',
    name: 'BUSINESS_DETAILS',
    type: Pages.BusinessDetails,
  },
  {
    step: 4,
    label: 'Store addresses',
    status: 'pending',
    name: 'STORE_ADDRESSES',
    type: Pages.MultiStores,
  },
  {
    step: 5,
    label: 'Bank account',
    status: 'pending',
    name: 'BANK_ACCOUNT',
    type: Pages.BankAccount,
  },
  {
    step: 6,
    label: 'Product requirements',
    status: 'pending',
    name: 'LEAD_PRODUCT',
    type: Pages.Products,
  },
  {
    step: 7,
    label: 'Pricing plan',
    status: 'pending',
    name: 'PRICING',
    type: Pages.PricingPlan,
  },

  {
    step: 8,
    label: 'KYC details',
    status: 'pending',
    name: 'KYC',
    type: Pages.KycDetails,
  },
  {
    step: 9,
    label: 'Capture photos',
    status: 'pending',
    name: 'CAPTURE_PHOTOS',
    type: Pages.CapturePhoto,
  },

  {
    step: 10,
    label: 'Review all details',
    status: 'pending',
    name: 'REVIEW',
    type: Pages.ReviewDetails,
  },
  {
    step: 11,
    label: 'Purchase order',
    name: 'PURCHASE',
    status: 'pending',
    type: Pages.PurchaseOrder,
  },
  {
    step: 12,
    label: 'Payment',
    name: 'PAYMENT',
    status: 'pending',
    type: Pages.POPayment,
  },
  {
    step: 13,
    label: 'NACH',
    status: 'pending',
    name: 'NACH',
    type: Pages.NachMandate,
  },
  {
    step: 14,
    label: 'Deployment',
    status: 'pending',
    name: 'Deployment',
    type: Pages.Deployment,
  },
]

// TODO: Move to constants
export const menuListPartnerShip: StepItem[] = [
  {
    step: 1,
    label: 'Lead details',
    status: 'pending',
    name: 'LEAD_CREATION',
    type: Pages.CreateLead,
  },

  {
    step: 2,
    label: 'PAN/ GST details',
    status: 'pending',
    name: 'PAN/GST',
    type: Pages.PanDetail,
  },
  {
    step: 3,
    label: 'Business details',
    status: 'pending',
    name: 'BUSINESS_DETAILS',
    type: Pages.BusinessDetails,
  },
  {
    step: 4,
    label: 'Store addresses',
    status: 'pending',
    name: 'STORE_ADDRESSES',
    type: Pages.MultiStores,
  },
  {
    step: 5,
    label: 'Bank account',
    status: 'pending',
    name: 'BANK_ACCOUNT',
    type: Pages.BankAccount,
  },
  {
    step: 6,
    label: 'Product requirements',
    status: 'pending',
    name: 'LEAD_PRODUCT',
    type: Pages.Products,
  },
  {
    step: 7,
    label: 'Pricing plan',
    status: 'pending',
    name: 'PRICING',
    type: Pages.PricingPlan,
  },

  {
    step: 8,
    label: 'KYC details',
    status: 'pending',
    name: 'KYC',
    type: Pages.PartnershipKyc,
  },
  {
    step: 9,
    label: 'Capture photos',
    status: 'pending',
    name: 'CAPTURE_PHOTOS',
    type: Pages.CapturePhoto,
  },

  {
    step: 10,
    label: 'Other Business Documents',
    status: 'pending',
    name: 'OTHERBUSINESS',
    type: Pages.OtherBusinessDoc,
  },

  {
    step: 11,
    label: 'Review all details',
    status: 'pending',
    name: 'REVIEW',
    type: Pages.ReviewDetails,
  },
  {
    step: 12,
    label: 'Purchase order',
    name: 'PURCHASE',
    status: 'pending',
    type: Pages.PurchaseOrder,
  },
  {
    step: 13,
    label: 'Payment',
    name: 'PAYMENT',
    status: 'pending',
    type: Pages.POPayment,
  },
  {
    step: 14,
    label: 'NACH',
    status: 'pending',
    name: 'NACH',
    type: Pages.NachMandate,
  },
  {
    step: 15,
    label: 'Deployment',
    status: 'pending',
    name: 'Deployment',
    type: Pages.Deployment,
  },
]

type StepDrawerProps = BoxProps & {
  onItemClick: (item: StepModel) => void
}

export const StepDrawer: React.FC<StepDrawerProps> = ({ onItemClick }) => {
  const [menus, setMenus] = useState([])
  const leadState = useAppSelector((state) => state.auth.leadState) as LeadStateModel
  const { selectedLeadId, stepNumber, selectedOppId } = useAppSelector((state) => state.lead)
  const [getStateQuery] = useLazyQuery(GET_LEAD_STATE)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [errorData, seterrorData] = useState({ type: '', message: '', code: '' })
  const [openErrorDialog, setopenErrorDialog] = useState(false)
  const { updateAlertDialog } = useContext(AlertDialogContext)

  const getLeadState = async () => {
    const stateDataId = localStorage.getItem('id')
    consoleLog('geLeadstate from stepdrawer = ' + selectedOppId)
    const idType = stateDataId || !selectedOppId ? 'LEAD' : 'OPPORTUNITY'
    let isExistingMerchant = undefined
    if (localStorage.getItem('isExisting') === 'true' && isEmpty(selectedOppId)) {
      isExistingMerchant = true
    }
    const { data, error } = await gqlCaller({
      gqlQuery: getStateQuery,
      dispatch,
      inputParams: {
        variables: {
          input: {
            idType,
            isExistingMerchant,
            stateDataId: stateDataId || selectedOppId,
            opportunityId: parseInt(selectedOppId),
          },
        },
        context: { isAuthRequired: true },
      },
      queryId: 8,
    })
    if (data != null) {
      consoleLog('inside data')
      dispatch(leadStateData(data))
    } else {
      consoleLog('inside error')
      seterrorData(error)
      setopenErrorDialog(true)
    }
  }

  const dialogOkayPressed = () => {
    setopenErrorDialog(false)
  }

  useEffect(() => {
    updateAlertDialog({
      title: errorData?.type,
      subText: errorData?.message,
      actionName: t('common.ok'),
      midIcon: <SVGCancel />,
      onActionClick: dialogOkayPressed,
      openDialog: openErrorDialog,
    })
  }, [openErrorDialog])

  useEffect(() => {
    getLeadState()
  }, [stepNumber, selectedLeadId, selectedOppId])

  let setInProgress = false

  useEffect(() => {
    if (leadState && leadState?.merchantOnboardingStateV2?.steps) {
      const temp = leadState?.merchantOnboardingStateV2?.steps.map((item) => {
        let status = 'pending'
        if (!item.editableConfig?.editable) {
          status = 'disabled'
        } else if (item.isComplete === true) {
          status = 'completed'
        } else {
          if (!setInProgress) {
            status = 'inprogress'
            setInProgress = true
          } else {
            status = 'pending'
          }
        }
        item = { ...item, status: status }
        return item
      })
      setMenus(temp)
    }
  }, [leadState])

  return (
    <Box
      sx={{
        borderRadius: '12px',
        border: 1,
        borderColor: BorderColor,
        p: 1.5,
        m: 4,
      }}
    >
      {menus?.map((item, index) => (
        <Step
          onItemClick={onItemClick}
          data={item}
          key={item.id}
          isLast={index === menus.length - 1}
        />
      ))}
    </Box>
  )
}

export default StepDrawer
